(function(angular, module) {var DOWN, DateFieldController, DropdownFieldController, ENTER, ESC, NumberFieldController, OptionFieldController, TAB, UP, ValueSearchController, YesNoFieldController, dybFieldController, extendScope, findParent, makeFieldDirective,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

UP = 38;

DOWN = 40;

ENTER = 13;

TAB = 9;

ESC = 27;

findParent = function() {
  var controller, element, i, len, name, names, parent;
  element = arguments[0], names = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  parent = element.parent();
  for (i = 0, len = names.length; i < len; i++) {
    name = names[i];
    controller = parent.controller(name);
    if (controller != null) {
      return controller;
    }
  }
  return null;
};

dybFieldController = (function() {

  /* @ngInject */
  function dybFieldController($injector, $scope, $element, $timeout, $attrs) {
    this.watchClasses = bind(this.watchClasses, this);
    this.focus = bind(this.focus, this);
    this.$destroy = bind(this.$destroy, this);
    this.injector = $injector;
    this.scope = $scope;
    this.element = $element;
    this.attrs = $attrs;
    this.timeout = $timeout;
    if (this.name == null) {
      throw new Error('No Name');
    }
    this.parent = findParent($element, 'dybSubForm', 'dybForm');
    this.form = $element.controller('dybForm');
    if (this.formData == null) {
      this.refreshData();
    }
    this.parent.addControl(this);
    this.scope.$on('$destroy', this.$destroy);
    this.scope.$watch(((function(_this) {
      return function() {
        return _this.classes;
      };
    })(this)), this.watchClasses, true);
    this.modelDebounce = {
      updateOn: 'default blur',
      debounce: {
        'default': 500,
        'blur': 0
      }
    };
  }

  Object.defineProperties(dybFieldController.prototype, {
    name: {
      get: function() {
        var ref;
        return this.attrName || ((ref = this.config) != null ? ref.name : void 0);
      }
    },
    label: {
      get: function() {
        var ref, ref1;
        return this.attrs.label || ((ref = this.config) != null ? ref.question : void 0) || ((ref1 = this.config) != null ? ref1.label : void 0);
      }
    },
    helpText: {
      get: function() {
        var ref, ref1;
        return this.attrs.helpText || ((ref = this.config) != null ? ref.helpText : void 0) || ((ref1 = this.config) != null ? ref1.help_text : void 0);
      }
    },
    viewData: {
      get: function() {
        return this.scope.data;
      }
    },
    formData: {
      get: function() {
        return this.parent.getFormData(this);
      },
      set: function(value) {
        return this.parent.setFormData(this, value);
      }
    },
    isEmpty: {
      get: function() {
        return (this.activeData == null) || this.activeData === "";
      }
    },
    activeData: {
      get: function() {
        if (this.form.isOpen) {
          return this.formData;
        } else {
          return this.viewData;
        }
      }
    },
    isFocused: {
      get: function() {
        return this._isFocused;
      },
      set: function(value) {
        this._isFocused = !!value;
        return this.element.toggleClass('focused', this._isFocused);
      }
    },
    isRequired: {
      get: function() {
        if (this.attrs.required == null) {
          return false;
        }
        if (this.attrs.required === "") {
          return true;
        }
        return this.required({
          field: this
        });
      }
    },
    hasIssue: {
      get: function() {
        var issue;
        if (this.attrs.issueWhen) {
          issue = this.issueEval({
            value: this.activeData,
            isEmpty: this.isEmpty,
            field: this
          });
          return issue;
        } else {
          return this.isEmpty;
        }
      }
    },
    hasChanged: {
      get: function() {
        return this.form.isOpen && this.formData !== this.viewData;
      }
    },
    isValid: {
      get: function() {
        var ref;
        return (ref = this.ngModel) != null ? ref.$valid : void 0;
      }
    },
    ngModel: {
      get: function() {
        return this.parent.ngForm[this.name];
      }
    },
    classes: {
      get: function() {
        return {
          'empty': this.isEmpty,
          'not-empty': !this.isEmpty,
          'has-issue': this.hasIssue,
          'no-issue': !this.hasIssue,
          'valid': this.isValid,
          'invalid': !this.isValid,
          'valid': this.isValid
        };
      }
    }
  });

  dybFieldController.prototype.$destroy = function() {
    this.parent.removeControl(this);
  };

  dybFieldController.prototype.refreshData = function() {
    this.formData = angular.copy(this.viewData);
  };

  dybFieldController.prototype.openForm = function(focusContext) {
    var fn, name, ref;
    this.form.open().then((function(_this) {
      return function() {
        return _this.timeout(function() {
          return _this.focus(focusContext);
        });
      };
    })(this));
    if (this.attrs.asyncValidate) {
      if (angular.isFunction(this.asyncValidate)) {
        this.asyncValidate = {
          async: this.asyncValidate
        };
      }
      ref = this.asyncValidate;
      for (name in ref) {
        fn = ref[name];
        this.ngModel.$asyncValidators[name] = fn;
      }
    }
  };

  dybFieldController.prototype.focus = function(context) {
    this.focusFirst("input", true);
    return this.focusFirst("textarea");
  };

  dybFieldController.prototype.focusFirst = function(tag, select) {
    var element;
    element = this.element.find(tag)[0];
    if (element != null) {
      element.focus();
    }
    if ((element != null) && select) {
      element.select();
    }
  };

  dybFieldController.prototype.pickClass = function(value, trueClass, falseClass) {
    this.element.toggleClass(trueClass, !!value);
    return this.element.toggleClass(falseClass, !value);
  };

  dybFieldController.prototype.watchClasses = function(classes) {
    var className, enabled;
    for (className in classes) {
      enabled = classes[className];
      this.element.toggleClass(className, !!enabled);
    }
  };

  dybFieldController.prototype.dispatchOnChange = function() {
    return this.onChange({
      $value: this.formData
    });
  };

  dybFieldController.prototype.toJSON = function() {
    return {
      viewData: this.viewData,
      formData: this.formData,
      activeData: this.activeData,
      isEmpty: this.isEmpty
    };
  };

  return dybFieldController;

})();

NumberFieldController = (function(superClass) {
  extend(NumberFieldController, superClass);

  function NumberFieldController() {
    return NumberFieldController.__super__.constructor.apply(this, arguments);
  }

  NumberFieldController.prototype.units = function() {
    if (!this.attrs.unit) {
      return "";
    } else if (this.activeData == null) {
      return this.attrs.unit;
    } else if (this.activeData === 1) {
      return this.attrs.unit.replace('(s)', '');
    } else {
      return this.attrs.unit.replace('(s)', 's');
    }
  };

  Object.defineProperties(NumberFieldController.prototype, {
    changeAmt: {
      get: function() {
        if (this.hasChanged) {
          return this.formData - this.viewData;
        } else {
          return 0;
        }
      }
    },
    changeMag: {
      get: function() {
        return Math.abs(this.changeAmt);
      }
    }
  });

  return NumberFieldController;

})(dybFieldController);

OptionFieldController = (function(superClass) {
  extend(OptionFieldController, superClass);

  function OptionFieldController() {
    return OptionFieldController.__super__.constructor.apply(this, arguments);
  }

  Object.defineProperties(OptionFieldController.prototype, {
    options: {
      get: function() {
        var ref;
        return this.scope.options || ((ref = this.config) != null ? ref.options : void 0) || [];
      }
    }
  });

  OptionFieldController.prototype.openForm = function(event, value) {
    if (!this.form.isOpen) {
      event.preventDefault();
    }
    return OptionFieldController.__super__.openForm.call(this, value);
  };

  OptionFieldController.prototype.focus = function(context) {
    if (this.formData == null) {
      this.formData = context;
    }
    return this.focusFirst('input');
  };

  OptionFieldController.prototype.getOptionValue = function(option) {
    var getter;
    getter = this.scope.optionValueGetter;
    if (getter != null) {
      return getter(option);
    } else {
      return option;
    }
  };

  return OptionFieldController;

})(dybFieldController);

YesNoFieldController = (function(superClass) {
  extend(YesNoFieldController, superClass);

  function YesNoFieldController() {
    return YesNoFieldController.__super__.constructor.apply(this, arguments);
  }

  return YesNoFieldController;

})(OptionFieldController);

DropdownFieldController = (function(superClass) {
  extend(DropdownFieldController, superClass);


  /* @ngInject */

  function DropdownFieldController($injector, $scope, $element, $timeout, $attrs) {
    this.keydown = bind(this.keydown, this);
    this.documentClick = bind(this.documentClick, this);
    this.closeDropdown = bind(this.closeDropdown, this);
    this.openDropdown = bind(this.openDropdown, this);
    DropdownFieldController.__super__.constructor.call(this, $injector, $scope, $element, $timeout, $attrs);
    this.document = $injector.get('$document');
    this.element.bind("keydown", this.keydown);
  }

  DropdownFieldController.prototype.openDropdown = function() {
    this.isFocused = true;
    this.dropdownOpen = true;
    this.element.addClass('dropdown-open');
    this.document.bind('mousedown', this.documentClick);
  };

  DropdownFieldController.prototype.closeDropdown = function() {
    this.dropdownOpen = false;
    this.element.removeClass('dropdown-open');
    this.document.bind('unbind', this.documentClick);
  };

  DropdownFieldController.prototype.apply = function(fn) {
    return this.scope.$apply(fn);
  };

  DropdownFieldController.prototype.documentClick = function(event) {
    if (!this.element[0].contains(event.target)) {
      return this.apply(this.closeDropdown);
    }
  };

  DropdownFieldController.prototype.keydown = function(event) {
    var ref;
    if (this.dropdownOpen && ((ref = event.which) === ENTER || ref === ESC || ref === TAB)) {
      this.apply(this.closeDropdown);
      if (event.which === ENTER) {
        return event.preventDefault();
      }
    } else if (!this.dropdownOpen && event.which === DOWN) {
      this.apply(this.openDropdown());
      return event.preventDefault();
    }
  };

  return DropdownFieldController;

})(dybFieldController);

DateFieldController = (function(superClass) {
  extend(DateFieldController, superClass);


  /* @ngInject */

  function DateFieldController($injector, $scope, $element, $timeout, $attrs) {
    this.closeDropdown = bind(this.closeDropdown, this);
    DateFieldController.__super__.constructor.call(this, $injector, $scope, $element, $timeout, $attrs);
    this.moment = $injector.get('moment');
  }

  DateFieldController.prototype.closeDropdown = function() {
    DateFieldController.__super__.closeDropdown.call(this);
    return this.reformatDate();
  };

  DateFieldController.prototype.blur = function() {
    this.isFocused = false;
    return this.reformatDate();
  };

  DateFieldController.prototype.clickDate = function() {
    if (this.formData) {
      this.formData = this.moment(this.formData);
    }
    this.dispatchOnChange();
    return this.closeDropdown();
  };

  DateFieldController.prototype.today = function() {
    this.formData = this.moment();
    this.reformatDate();
    this.dispatchOnChange();
  };

  DateFieldController.prototype.clear = function() {
    this.formData = null;
    this.reformatDate();
    this.dispatchOnChange();
  };

  DateFieldController.prototype.cancel = function() {
    this.refreshData();
    this.reformatDate();
    this.dispatchOnChange();
    return this.closeDropdown();
  };

  DateFieldController.prototype.reformatDate = function() {
    if (this.formData && this.formData.clone) {
      return this.formData = this.formData.clone();
    }
  };

  return DateFieldController;

})(DropdownFieldController);

ValueSearchController = (function(superClass) {
  extend(ValueSearchController, superClass);

  function ValueSearchController() {
    this.listClick = bind(this.listClick, this);
    this.keydown = bind(this.keydown, this);
    this.updateList = bind(this.updateList, this);
    this.clear = bind(this.clear, this);
    return ValueSearchController.__super__.constructor.apply(this, arguments);
  }

  ValueSearchController.prototype.refreshData = function() {
    var ref;
    ValueSearchController.__super__.refreshData.call(this);
    this.searchText = ((ref = this.formData) != null ? ref.name : void 0) != null ? this.formData.name : "";
    return this.searchChanged = false;
  };

  ValueSearchController.prototype.clear = function() {
    this.searchText = "";
    this.formData = void 0;
    return this.closeDropdown();
  };

  ValueSearchController.prototype.openDropdown = function() {
    ValueSearchController.__super__.openDropdown.call(this);
    return this.updateList();
  };

  ValueSearchController.prototype.closeDropdown = function() {
    ValueSearchController.__super__.closeDropdown.call(this);
    if (this.searchText === '' && !this.formData) {
      this.formData = void 0;
      this.searchChanged = false;
      return;
    } else if (this.selectedIndex === -1 && this.searchChanged) {
      this.selectByIndex(0);
    }
    this.searchChanged = false;
    return this.searchText = this.formData != null ? this.formData.name : "";
  };

  ValueSearchController.prototype.updateList = function(query) {
    var ref;
    this.selectedIndex = -1;
    if ((ref = this.element.find('ul')[0]) != null) {
      ref.scrollTop = 0;
    }
    if (!this.dropdownOpen) {
      this.openDropdown();
    }
    if (query != null) {
      this.searchChanged = true;
    }
    return this.scope.doSearch({
      query: query
    }).then((function(_this) {
      return function(items) {
        return _this.staff = items;
      };
    })(this));
  };

  ValueSearchController.prototype.keydown = function(event) {
    var ref;
    if (this.dropdownOpen && ((ref = event.which) === UP || ref === DOWN)) {
      event.preventDefault();
      this.scope.$apply((function(_this) {
        return function() {
          _this.selectedIndex += event.which - (UP + 1);
          return _this.selectByIndex(_this.selectedIndex);
        };
      })(this));
      return;
    }
    return ValueSearchController.__super__.keydown.call(this, event);
  };

  ValueSearchController.prototype.selectByIndex = function(index) {
    var item_offset, items, list;
    index = Math.min(this.staff.length - 1, Math.max(0, index));
    this.selectedIndex = index;
    this.formData = this.staff[index];
    list = this.element.find('ul')[0];
    if (list) {
      items = list.children;
      item_offset = items[index].offsetTop + items[index].offsetHeight;
      return list.scrollTop = item_offset - list.offsetHeight;
    }
  };

  ValueSearchController.prototype.listClick = function(index) {
    this.selectByIndex(index);
    return this.closeDropdown();
  };

  return ValueSearchController;

})(DropdownFieldController);

extendScope = function(scope) {
  scope.data = '=value';
  return scope;
};

makeFieldDirective = function(type, controller, scope) {
  var capitalized, directiveName;
  if (controller == null) {
    controller = dybFieldController;
  }
  if (scope == null) {
    scope = {};
  }
  capitalized = type[0].toUpperCase() + type.slice(1);
  directiveName = "dyb" + capitalized + "Field";
  return module.directive(directiveName, function() {
    return {
      restrict: 'E',
      require: ['^dybForm', directiveName],
      templateUrl: "forms/" + type + "Field",
      scope: extendScope(scope),
      controllerAs: 'ctrl',
      controller: controller,
      transclude: {
        messages: '?ngMessage',
        label: '?radioLabel',
        help: '?helpText'
      },
      bindToController: {
        issueEval: '&issueWhen',
        required: '&',
        config: '=',
        onChange: '&',
        asyncValidate: '=',
        attrName: '@?name'
      },
      link: function(scope, element, attrs, controllers) {
        var ctrl, dybForm;
        dybForm = controllers[0], ctrl = controllers[1];
        element.addClass("dyb-field");
        element.addClass("dyb-field-" + type);
        scope.type = type;
      }
    };
  });
};

makeFieldDirective("text");

makeFieldDirective("textarea");

makeFieldDirective("number", NumberFieldController, {
  min: '=',
  max: '='
});

makeFieldDirective("yesNo", YesNoFieldController);

makeFieldDirective("checkbox");

makeFieldDirective('select', OptionFieldController, {
  options: '=',
  optionValueGetter: '=?'
});

makeFieldDirective("radios", OptionFieldController, {
  options: '=',
  optionValueGetter: '=?'
});

makeFieldDirective('date', DateFieldController);

makeFieldDirective('time');

makeFieldDirective('ybusaStaff', ValueSearchController, {
  doSearch: '&search'
});

module.directive('dybFieldTranscludeProxy', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs, controller, transclude) {
      var definitions, i, len, name, ref;
      if (!transclude) {
        return;
      }
      definitions = {};
      ref = attrs.dybFieldTranscludeProxy.split(',');
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        definitions[name] = {
          get: function() {
            return scope[name];
          }
        };
      }
      Object.defineProperties(scope.$$childHead, definitions);
    }
  };
});
})(angular, angular.module("dybForms"));